export const API_ENDPOINTS = {
  userResources: '/user-resources?suggestions=true',
  userProfile: '/api/v2/user/profile',
  loyaltyProfile: '/api/v2/loyaltyProgram/profile',
  address: '/endereco'
}
